import React from 'react'

const EllipsisIcon = props => (
  <svg viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3.91304C0.8956 3.91304 0 3.03691 0 1.95652C0 0.875739 0.8956 0 2 0C3.1044 0 4 0.875739 4 1.95652C4 3.03691 3.1044 3.91304 2 3.91304ZM4 9C4 7.91922 3.1044 7.04348 2 7.04348C0.8956 7.04348 0 7.91922 0 9C0 10.0804 0.8956 10.9565 2 10.9565C3.1044 10.9565 4 10.0804 4 9ZM2 14.087C3.1044 14.087 4 14.9627 4 16.0435C4 17.1239 3.1044 18 2 18C0.8956 18 0 17.1239 0 16.0435C0 14.9627 0.8956 14.087 2 14.087Z"
      fill="#8394A3"
    />
  </svg>
)

export default EllipsisIcon
